if (typeof jQuery != "undefined") {
    (function($) {
        "use strict";

        /** AddForm
         *
         * Removes addBtn after successful submitting of it's containing form.
         * (Specifically used for 'add new postal address' functionality)
         *
         **/
        ZZ.AddForm = function(addBtn) {
            var base = this;
            base.addBtn = addBtn;

            var buttonsContainer = base.addBtn.parent();
            base.editBtn = buttonsContainer.find(".change:not(.add)");
            base.editBtn.css("display", "none");

            base.submitBtn = buttonsContainer.find(".confirm");

            base.assignListeners();
        };

        ZZ.AddForm.prototype = {
            assignListeners: function() {
                var base = this;

                $(window).on("zz_formsubmit_succes", function(e, id) {
                    if (id === base.submitBtn.attr("id")) {
                        base.onSuccess();
                    }
                });
            },

            onSuccess: function() {
                // destroy 'add' functionality
                this.destroy();
            },

            destroy: function() {
                var base = this;
                base.addBtn.off();
                base.addBtn.remove();
                base.editBtn.css("display", "");
            }
        };
    })(jQuery);
}
